/* eslint-disable max-len */
/**
 * SEO通用配置
 */

// 通用描述配置
const description = 'Master 11+ maths questions with speed and accuracy. Our online 11+ maths courses prepare candidates for entry to their chosen grammar or independent school.';
// 通用关键词配置
const keywords = 'Think Academy MYS, maths tuition, after school tuition, TAL, Xueersi, 100tal, grammar school, public school';

export default {
  common: {
    // Logo Alt描述
    logoDescription: 'Think Academy MYS',
  },
  home: {
    title: 'Think Academy MYS – Interactive Online Maths Courses',
    description: 'EdTech-powered interactive online maths courses for students ages 5 – 11, Think Academy helps children achieve their full potential in maths.',
    keywords,
  },
  coursesList: {
    title: 'Maths Courses',
    description: 'Master 11+ maths questions with speed and accuracy. Our online 11+ maths courses prepare candidates for entry to their chosen grammar or independent school.',
    keywords,
  },
  coursesDetail: {
    title: '{title}Think Academy MYS',
    description: 'Master 11+ maths questions with speed and accuracy. Our online 11+ maths courses prepare candidates for entry to their chosen grammar or independent school.',
    keywords,
  },
  privacyPolicy: {
    title: 'Privacy Policy - Think Academy MYS',
    description,
    keywords,
  },
  cookiesPolicy: {
    title: 'Cookie Policy - Think Academy MYS',
    description,
    keywords,
  },
  termsOfUse: {
    title: 'Terms of Use - Think Academy MYS',
    description,
    keywords,
  },
  safeguardingPolicy: {
    title: 'Safeguarding Policy - Think Academy MYS',
    description,
    keywords,
  },
  faq: {
    title: 'FAQs - Think Academy MYS',
    description,
    keywords,
  },
  freeAssessment: {
    title: '1-To-1 Assessment by Think Academy',
    description: 'Through a personalised assessment with our teachers, learn about your Kindergarten 2 to Primary 5 child\'s knowledge and skills level across 7 key Math abilities, and how you can support his or her learning and growth.',
    keywords,
  },
  teachers: {
    title: 'Think Academy - Meet Our Team of Experienced Educators',
    description: 'All Think Academy teachers are experienced educators who are passionate about helping our students succeed.',
    keywords: 'kids math tutors near me, math tutor centers near me, online math tutoring, kids math program',
  },
  classChangeRules: {
    title: 'Reschedule/Transfer Rules - Think Academy MYS',
    description,
    keywords,
  },

}
